import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import {
	AutoCompleteItem as DropdownAutoCompleteItem,
	Dropdown,
} from "@/components/Dropdown/Dropdown";
import { Information } from "@/components/Information/Information";

import {
	PipedriveSyncTriggerWithInherit,
	PipedriveListSyncTriggerResponse,
} from "../../../../Company/schema/pipedrive";

interface PipedriveSyncSectionProps {
	isPipedriveEnabled: boolean;
	isConnected: boolean;
	listSyncTrigger: PipedriveListSyncTriggerResponse | undefined;
	selectedPipedriveSyncTrigger: PipedriveSyncTriggerWithInherit | undefined;
	setSelectedPipedriveSyncTrigger: (trigger: PipedriveSyncTriggerWithInherit) => void;
}

export const PipedriveSyncSection: FunctionComponent<PipedriveSyncSectionProps> = ({
	isPipedriveEnabled,
	isConnected,
	listSyncTrigger,
	selectedPipedriveSyncTrigger,
	setSelectedPipedriveSyncTrigger,
}) => {
	const { t } = useTranslation();
	const tsSettings = (key: string) => t(`list.settings.${key}`);

	if (!isPipedriveEnabled || !isConnected) {
		return null;
	}

	return (
		<div className="flex flex-col w-full mt-8">
			<div className="flex flex-col gap-2 w-full mb-4">
				<div className="text-ssm font-medium text-text">
					{tsSettings("pipedrive.syncTrigger.title")}{" "}
					<Information information={tsSettings("pipedrive.syncTrigger.description")} />
				</div>
			</div>
			<Dropdown
				data={[
					{
						title: tsSettings("pipedrive.syncTrigger.INHERIT"),
						id: PipedriveSyncTriggerWithInherit.INHERIT,
					},
					{
						title: tsSettings("pipedrive.syncTrigger.DISABLED"),
						id: PipedriveSyncTriggerWithInherit.DISABLED,
					},
					{
						title: tsSettings("pipedrive.syncTrigger.ON_CAMPAIGN_START"),
						id: PipedriveSyncTriggerWithInherit.ON_CAMPAIGN_START,
					},
					{
						title: tsSettings("pipedrive.syncTrigger.ON_REPLY"),
						id: PipedriveSyncTriggerWithInherit.ON_REPLY,
					},
				]}
				defaultValue={
					selectedPipedriveSyncTrigger
						? {
								id: selectedPipedriveSyncTrigger,
								title: tsSettings(`pipedrive.syncTrigger.${selectedPipedriveSyncTrigger}`),
							}
						: undefined
				}
				floating={true}
				handleSelect={(value: DropdownAutoCompleteItem) => {
					setSelectedPipedriveSyncTrigger(value.id as PipedriveSyncTriggerWithInherit);
				}}
			/>
			{listSyncTrigger?.isInherited && (
				<div className="text-ssm text-text-meta mt-2">
					{tsSettings("pipedrive.syncTrigger.inheritedFrom")}:{" "}
					{tsSettings(`pipedrive.syncTrigger.${listSyncTrigger.effectiveTrigger}`)}
				</div>
			)}
		</div>
	);
};
